const Language = (state = '', action) => {
    switch (action.type) {
        case 'SET_LANG_DATA':
            return action.payload
        default:
            return state
    }
}
export default Language